import { useEffect } from "react";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";

/** Injects the Tawk.to widget once. Skipped on admin routes. */
export default function TawkTo() {
  const { settings } = useSiteSettings();
  useEffect(() => {
    if (!settings?.tawk_enabled || !settings?.tawk_src) return;
    if (window.__tawk_loaded) return;
    if (typeof window.location !== "undefined" && window.location.pathname.startsWith("/admin")) return;
    window.__tawk_loaded = true;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const s = document.createElement("script");
    s.async = true;
    s.src = settings.tawk_src;
    s.charset = "UTF-8";
    document.body.appendChild(s);
  }, [settings]);
  return null;
}
